import React from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import ZotzonAvatar from 'components/shared/elements/images/ZotzonAvatar';
import { formatUserTime } from 'lib/timezone';
import { useAuthContext } from 'components/shared/Auth';

export default function ChatMessage({
  messageItem,
  usersById,
  getMessageUserId,
  getUserName,
  currentUserId,
  lastComment,
  previewMode = false,
}) {
  const { userData } = useAuthContext();
  const messageUserId = getMessageUserId(messageItem);
  const messageUser = messageItem?.user || (messageUserId ? usersById?.[messageUserId] : null);
  const itMy = messageUserId && currentUserId ? String(messageUserId) === String(currentUserId) : false;
  const messageTime = formatUserTime(messageItem?.created_at, userData?.timezone);
  const avatarSrc = messageUser?.avatarUrl || messageUser?.avatar || messageUser?.icon;
  const avatarBackupSrc = messageUser?.avatar_backup || messageUser?.avatarBackup || null;

  return (
    <div>
      {!itMy && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            marginBottom: 2,
            marginLeft: 12,
          }}
        >
          {avatarSrc ? (
            <ZotzonAvatar
              src={avatarSrc}
              backupSrc={avatarBackupSrc}
              alt={getUserName(messageUser)}
              style={{ width: 20, height: 20, objectFit: 'cover' }}
            />
          ) : (
            <Avatar size={20} icon={<UserOutlined />} />
          )}
          <span style={{ fontSize: 12, color: '#555', fontWeight: 500 }}>{getUserName(messageUser)}</span>
        </div>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: itMy ? 'flex-end' : 'flex-start',
          marginBottom: 4,
          padding: '0 8px',
        }}
      >
        <div
          style={{
            maxWidth: '80%',
            minWidth: 80,
            background: lastComment === messageItem?.id ? '#dde7fa' : itMy ? '#eaf2fd' : '#fff',
            borderRadius: 8,
            padding: '6px 10px',
            position: 'relative',
            marginLeft: itMy ? 0 : 28,
            boxShadow: previewMode ? 'none' : '0 1px 2px rgba(0,0,0,0.08)',
            border: itMy ? 'none' : '1px solid #f0f0f0',
          }}
        >
          <div
            style={{
              paddingRight: 40,
              paddingBottom: 2,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: 14,
            }}
          >
            {messageItem?.message}
          </div>
          <span
            style={{
              position: 'absolute',
              bottom: 4,
              right: 8,
              fontSize: 10,
              color: '#999',
            }}
          >
            {messageTime}
          </span>
        </div>
      </div>
    </div>
  );
}
